import React, { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";
import "./ScrollToTopButton.css";

const ScrollToTopButton = ({ scrollContainerSelector }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const getContainer = () => {
      if (scrollContainerSelector) {
        return document.querySelector(scrollContainerSelector);
      }
      return null;
    };

    const handleScroll = () => {
      const container = getContainer();
      if (container) {
        setVisible(container.scrollTop > 200);
      } else {
        setVisible(window.scrollY > 200);
      }
    };

    const container = getContainer();
    const target = container || window;
    target.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => target.removeEventListener("scroll", handleScroll);
  }, [scrollContainerSelector]);

  const handleClick = () => {
    if (scrollContainerSelector) {
      const container = document.querySelector(scrollContainerSelector);
      if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      className="scroll-to-top-button"
      onClick={handleClick}
      title="Scroll to top"
    >
      <ChevronUp size={20} />
    </button>
  );
};

export default ScrollToTopButton;
